module.exports = __webpack_public_path__ + "static/media/msBlueLogo.73873e47.svg";